import React, { useState, useEffect } from 'react';
import './Testimonials.scss';
import { getTopTestimonials } from '../../firebase/testimonials.store';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        setLoading(true);
        const data = await getTopTestimonials();
        setTestimonials(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching testimonials:', err);
        setError('Failed to load testimonials');
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span
        key={index}
        className={`star ${index < rating ? 'filled' : 'empty'}`}
      >
        ★
      </span>
    ));
  };

  const formatDate = (date) => {
    // Handle both Date objects and Firestore Timestamps
    const dateObj = date?.toDate ? date.toDate() : new Date(date);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(dateObj);
  };

  if (loading) {
    return (
      <div className="testimonials">
        <div className="testimonials__container">
          <div className="testimonials__header">
            <h2 className="testimonials__title">What Our Customers Say</h2>
            <p className="testimonials__subtitle">
              Don't just take our word for it - hear from our satisfied customers
            </p>
          </div>
          <div className="testimonials__loading">
            <div className="loading-spinner"></div>
            <p>Loading testimonials...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="testimonials">
        <div className="testimonials__container">
          <div className="testimonials__header">
            <h2 className="testimonials__title">What Our Customers Say</h2>
            <p className="testimonials__subtitle">
              Don't just take our word for it - hear from our satisfied customers
            </p>
          </div>
          <div className="testimonials__error">
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (testimonials.length === 0) {
    return null;
  }

  return (
    <div className="testimonials">
      <div className="testimonials__container">
        
        <div className="testimonials__scroll-container">
          <div className="testimonials__list">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-card__header">
                  <div className="testimonial-card__avatar">
                    {testimonial.thumbnailUrl ? (
                      <img
                        src={testimonial.thumbnailUrl}
                        alt={testimonial.name}
                        className="testimonial-card__image"
                      />
                    ) : (
                      <div className="testimonial-card__placeholder">
                        {testimonial.name.charAt(0)}
                      </div>
                    )}
                  </div>
                  <div className="testimonial-card__info">
                    <h4 className="testimonial-card__name">{testimonial.name}</h4>
                    <div className="testimonial-card__rating">
                      {renderStars(testimonial.starRating)}
                    </div>
                    <p className="testimonial-card__date">
                      {formatDate(testimonial.date)}
                    </p>
                  </div>
                </div>
                <div className="testimonial-card__content">
                  <p className="testimonial-card__message">
                    "{testimonial.message}"
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
